import { CardMediaSlot } from "@/components/landing/CardMediaSlot";

export function CompanySnapshot({ content, media = [] }) {
  return (
    <section id="overview" className="section snapshot-section" data-slide="01" data-testid="company-snapshot-section">
      <div className="snapshot-layout">
        <div className="section-heading snapshot-heading">
          <p className="overline" data-testid="snapshot-overline">{content.overline}</p>
          <h2 data-testid="snapshot-title">{content.title}</h2>
          <p data-testid="snapshot-description">{content.description}</p>
        </div>

        <div className="snapshot-facts" data-testid="snapshot-facts">
          {content.facts.map((fact, index) => (
            <article className="snapshot-fact" key={fact.label} data-testid={`snapshot-fact-${index + 1}`}>
              <CardMediaSlot image={media[index]?.image} label={fact.label} testId={`snapshot-media-${index + 1}`} className="compact-media" />
              <span data-testid={`snapshot-fact-label-${index + 1}`}>{fact.label}</span>
              <strong data-testid={`snapshot-fact-value-${index + 1}`}>{fact.value}</strong>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}